/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_ThanksInputs */

const ja_playdata_home_newsletter_thanks = /** @type {(inputs: Playdata_Home_Newsletter_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メルマガ登録いただきありがとうございました！`)
};

const en_playdata_home_newsletter_thanks = /** @type {(inputs: Playdata_Home_Newsletter_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for subscribing.`)
};

/**
* | output |
* | --- |
* | "Thank you for subscribing." |
*
* @param {Playdata_Home_Newsletter_ThanksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_thanks = /** @type {((inputs?: Playdata_Home_Newsletter_ThanksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_ThanksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_thanks(inputs)
	return en_playdata_home_newsletter_thanks(inputs)
});